import {ListItemButton, styled} from "@mui/material";

const StyledListItemButton = styled((props) => <ListItemButton {...props} />)(
  ({ theme }) => {
    return {
      transition: "all ease 400ms",
      padding: "10px 14px",
      color: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        color: "white",
      },
      "&.active": {
        boxShadow:
          "0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)",
        backgroundColor: theme.palette.primary.main,
        color: "white",
      },
    };
  }
);

export default StyledListItemButton;
